"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Activity, Home } from "lucide-react";

export default function Header({ badge }: { badge?: string }) {
  const pathname = usePathname();
  const isHome = pathname === "/";
  const isAnalyze = pathname === "/analyze";

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        borderBottom: "1px solid var(--border-subtle)",
        background: "rgba(11, 11, 15, 0.8)",
        backdropFilter: "blur(16px)",
        WebkitBackdropFilter: "blur(16px)",
      }}
    >
      <div
        className="container"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: 56,
        }}
      >
        <Link
          href="/"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            fontWeight: 600,
            fontSize: "1.0625rem",
            letterSpacing: "-0.02em",
          }}
        >
          <div
            style={{
              width: 28,
              height: 28,
              borderRadius: 6,
              background: "var(--accent-gradient)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Activity size={15} color="#fff" strokeWidth={2.5} />
          </div>
          <span className="gradient-text">SoundBench</span>
        </Link>

        <nav style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Link
            href="/"
            className="btn btn-ghost"
            style={{
              padding: "6px 14px",
              fontSize: "0.8125rem",
              opacity: isHome ? 1 : 0.7,
              borderColor: isHome ? "var(--border-medium)" : undefined,
            }}
          >
            <Home size={14} />
            Home
          </Link>
          <Link
            href="/analyze"
            className="btn btn-ghost"
            style={{
              padding: "6px 14px",
              fontSize: "0.8125rem",
              opacity: isAnalyze ? 1 : 0.7,
              borderColor: isAnalyze ? "var(--border-medium)" : undefined,
            }}
          >
            <Activity size={14} />
            Analyze
          </Link>
          {badge && (
            <span
              style={{
                marginLeft: 8,
                fontSize: "0.75rem",
                color: "var(--text-muted)",
                fontWeight: 500,
              }}
            >
              {badge}
            </span>
          )}
        </nav>
      </div>
    </header>
  );
}
